document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector(".newsletter-form")
  form.addEventListener("submit", (event) => {
    event.preventDefault()
    setTimeout(() => {
      const successMessage = document.getElementsByClassName(
        "newsletter-form__message--success",
      )
      if (successMessage) {
        dataLayer.push({
          event: "email_newsletter_sign_up",
          page_location: window.location.href,
        })
      } else {
        dataLayer.push({
          event: "email_newsletter_sign_up_fail",
          page_location: window.location.href,
        })
      }
    }, 1000)
  })
})
